import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'deletemodal',
  templateUrl: './deletemodal.component.html',
  styleUrls: ['./deletemodal.scss'],
})
export class DeleteModal {
  @Input() message: any;
  @Input() dialogRef: any;

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onSubmitClick(): void {
    this.dialogRef.close(true);
  }
}
